<template>
  <svg :width="width" :height="height" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path :class="setCheckColor() ? 'order-complete' : 'order-incomplete'"
          d="M24.8016 50C-8.2672 48.9286 -8.2672 1.07143 24.8016 0C57.8704 1.07143 57.8704 48.9286 24.8016 50ZM24.8016 3.57143C-3.61969 4.46429 -3.61969 45.5357 24.8016 46.4286C53.2229 45.5357 53.2229 4.46429 24.8016 3.57143ZM38.5654 17.6786L21.2266 35C20.5116 35.7143 19.4391 35.7143 18.7241 35L11.0378 27.3214C9.42907 25.7143 11.9316 23.2143 13.5403 24.8214L19.9753 31.25L36.0628 15.1786C37.6716 13.3929 40.1741 16.0714 38.5654 17.6786Z"/>
  </svg>
</template>

<script>
export default {
  name: "orderConfirmationCheck",
  props: {orderStatus: String, selectedOrderNumber: Number},
  methods: {
    setCheckColor() {
      if (this.$route.name === 'account') {
        // This will keep the size right when using the order popup
        if(this.selectedOrderNumber > 0) {
          this.width = 44
          this.height = 44
          return true
        }
        // This sets the checkbox to the correct size for the tracking page
        this.width = 26
        this.height = 26
        return this.orderStatus === 'Delivery Completed'
      }
      // This keeps the checkmark at the correct size in all other scenarios
      this.width = 44
      this.height = 44
      return false
    }
  },
  data() {
    return {
      height: 44,
      width: 44
    }
  }
}
</script>

<style scoped>
.order-incomplete {
  fill: #fff;
}

.order-complete {
  fill: #41b029;
  height: 30px;
  width: 30px;
}
</style>
